module.exports = __webpack_public_path__ + "img/warning.8bd0a598.svg";